import { makeRequest } from 'utils/requestLogger';

export default (id, google_classroom_course_id, google_classroom_course_name, classroom_users) =>
    makeRequest('put', `/api/integrations/google/sso/courses${id}/sync-course/${google_classroom_course_id}`, {
        google_classroom_course_name,
        classroom_users,
    });



// WEBPACK FOOTER //
// ./src/app/services/courses/syncGoogleClassroomCourse.js